import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import { Visible } from 'react-grid-system';
import OfferRequestButtonWrapper from '../../../modals/OfferRequestModals/OfferRequestButtonWrapper';
import DealerCheckIcon from '../../../ui/SVG/DealerCheckIcon';
import { supportPhone, supportPhoneLink } from '../../../../framework/constants/app';
import styles from './Sidebar.styl';
export const Sidebar = React.forwardRef((props, ref) => {
    const { t } = props;
    return (React.createElement("div", { className: styles.sidebar, ref: ref },
        React.createElement("div", { className: `${styles.text} ${styles.mobileHide}` },
            React.createElement(IconSVG, { name: 'checked', customDimensions: true, className: styles.icon }),
            t('slider.checked')),
        React.createElement("div", { className: `${styles.text} ${styles.mobileHide}` },
            React.createElement(IconSVG, { name: 'easy', customDimensions: true, className: styles.icon }),
            t('slider.easy')),
        React.createElement("div", { className: `${styles.text} ${styles.mobileHide}` },
            React.createElement(IconSVG, { name: 'safe', customDimensions: true, className: styles.icon }),
            t('slider.safe')),
        React.createElement("div", { className: `${styles.text} ${styles.mobileHide}` },
            React.createElement(IconSVG, { name: 'toBuy', customDimensions: true, className: styles.icon }),
            t('slider.toBuy')),
        React.createElement("div", { className: `${styles.text} ${styles.phoneNumber}` },
            React.createElement("a", { href: `tel:${supportPhoneLink}` },
                React.createElement(IconSVG, { name: 'grayPhoneIcon', customDimensions: true, className: styles.phoneIcon }),
                React.createElement("span", { className: styles.mobileHide },
                    supportPhone,
                    " ",
                    React.createElement("span", { className: styles.light },
                        "(",
                        t('slider.callForFree'),
                        ")")))),
        React.createElement(OfferRequestButtonWrapper, null, (onClick, isOfferRequested, hasCheckout, isAuthorized, isLoading) => {
            const offerButtonClassName = classnames(styles.offerButtonGet, { [styles.offerButtonSuccess]: isAuthorized && isOfferRequested });
            return (React.createElement(Button, { className: offerButtonClassName, variant: 'filled', onClick: onClick, disabled: isLoading }, isLoading ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : React.createElement(React.Fragment, null,
                isAuthorized && isOfferRequested ? React.createElement(DealerCheckIcon, { className: styles.checkIcon }) : null,
                isAuthorized && isOfferRequested ? t('sidebar.successfullyRequested') : t('sidebar.requestOffer'),
                React.createElement(Visible, { xs: true, sm: true, md: true },
                    React.createElement(IconSVG, { name: 'whiteEnvelope', customDimensions: true, className: styles.shoppingCart })))));
        }),
        React.createElement("a", { href: '/', className: styles.logo })));
});
